export default __webpack_public_path__ + "static/skill-light-170cffda4c0785f1bcf4f9d75e10c56e83de9d5c86d33e91fbd5d7fe0ceb6b57.png";